module.exports = "<div class=other-login-main> <div class=select-prompt>请选择登录人员：</div> <div class=user-list></div> <div class=other-login-footer> <button type=button class=confirm-btn>确定</button> <button type=button class=cancel-btn>取消</button> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/main/login-by-other/login-by-other.html
// module id = 2093
// module chunks = 50